import { connect } from 'react-redux';
import ReportsFilter from './reports-filter';
import {
  selectReport,
  removeReportData,
} from '../../../reducers/reports.reducers';
import { comparisonOptionNames } from '../../../models';

const mapStateToProps = (state) => {
  const { selectedLocation, reports } = state.reports;

  const reportIds = selectedLocation ? [...selectedLocation.reportAssignments.map(ra => ra.reportId)] : [];

  const locationIds = state.filter.comparisonDateRanges
    .filter(cdr => cdr.option !== comparisonOptionNames.none).map(cdr => cdr.locationId);


  const activeLocations = state.reports.locations.filter(l => locationIds.includes(l.id));
  const locationReports = activeLocations.map(l => l.reportAssignments.map(ra => ra.reportId)).flat();


  locationReports.forEach((lr) => {
    if (!reportIds.includes(lr)) {
      reportIds.push(lr);
    }
  });


  return {
    reports: reports.filter(r => reportIds.includes(r.reportID)),
    selectedReport: state.reports.selectedReport,
    isLoading: !!state.loading.loaders.loadLocations,
  };
};

const mapDispatchToProps = dispatch => ({
  selectReport: id => dispatch(selectReport(id)),
  removeReportData: id => dispatch(removeReportData(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsFilter);
